import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";

import {useAppSelector} from "../../store/hooks";

export const UserContactDataForm = () => {
    const codes = useAppSelector((state) => state.variables.data?.country_codes);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" />
            <InputField name="email" placeholder="E-mail" />
            <PhoneFieldControlled name="phone" codes={codes ?? []} placeholder="Numer telefonu" maxMenuHeight={200} />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";

import {useAppSelector} from "../../store/hooks";

export const UserContactDataForm = () => {
    const codes = useAppSelector((state) => state.variables.data?.country_codes);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" />
            <InputField name="email" placeholder="E-mail" />
            <PhoneFieldControlled name="phone" codes={codes ?? []} placeholder="Numer telefonu" maxMenuHeight={200} />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
